'use strict';

export class MainScript {

    constructor() {
        this.initEvent();
    }

    initEvent() {
        const instance = this

        $(document).on('click', '.js-remove-small-basket', function () {
            let id = $(this).parents('.js-basket-element').data('basket-id')
            let productId = $(this).parents('.js-basket-element').data('product-id')
            let basketBtn = $('[data-element-id="'+productId+'"]').find('.js-add-to-basket')
            let basketBtnAdded = $('[data-element-id="'+productId+'"]').find('.js-basket-added')

            $.ajax({
                url: '/local/ajax/api/basket/delete.php',
                data: {id: id},
                success: function () {
                    $('[data-basket-id="'+id+'"]').remove()
                    if (basketBtnAdded) {
                        basketBtnAdded.addClass('d-none')
                    }
                    if (basketBtn) {
                        basketBtn.removeClass('d-none')
                    }
                    instance.updateBasket()
                },
                error: function (e) {
                    alert(e);
                }
            })
        });

        $(document).on('click', '.js-remove-small-basket-set', function () {

            let idElement = $(this).parents('.js-basket-element').data('constructor');
            let ids = [];
            $('[data-constructor="'+idElement+'"]').each(function(){
                ids.push($(this).data('basket-id'));
            })
            $.ajax({
                url: '/local/ajax/api/basket/delete-set.php',
                data: {id: ids},
                success: function () {
                    $('[data-constructor="'+idElement+'"]').remove();
                    instance.updateBasket()
                },
                error: function (e) {
                    alert(e);
                }
            })
        });

        $(document).on('click', '.js-add-to-basket', function () {
            let element = $(this);
            let id = element.data('id');
            let quantity = 1;

            if (element.parents('.js-item').find('input[name="quantity"]')) {
                quantity = element.parents('.js-item').find('input[name="quantity"]').val();
            }

            if (element.parents('.js-item-detail').find('input[name="quantity"]')) {
                quantity = element.parents('.js-item-detail').find('input[name="quantity"]').val();
            }

            $.ajax({
                url: '/local/ajax/api/basket/add.php',
                data: {id: id, quantity: quantity},
                success: function () {
                    element.parents('.card').find('.card__add-wrap').find('.btn--plus').addClass('is-check');
                    element.parents('.card').find('.card__add-wrap').append('<div class="dropdown-menu' +
                        ' dropdown-menu-end text-center p-16">'+
                        '<div class="mb-16">Товар добавлен в корзину</div>'+
                        '<a class="btn w-100 mb-8" href="/personal/basket/">Перейти в корзину</a>'+
                        '<a class="link link--main fw-600" href="/local/ajax/popups/fast_order.php?id='+id+'" data-fancybox data-type="ajax" data-touch="false">Оформить в один клик</a>'+
                    '</div>');
                    element.parents('.js-item-detail').find('.js-basket-added').removeClass('d-none');
                    element.parents('.js-item-detail').find('.js-add-to-basket').addClass('d-none');
                    instance.updateBasket()
                },
                error: function (e) {
                    alert(e);
                }
            })
        });
    }

    updateBasket()
    {
        $.ajax({
            url: '/local/ajax/popups/basket_update.php',
            success: function (e) {
                $('#head-basket').html(e);
            },
            error: function (e) {
                alert(e);
            }
        })
    }

    getList(id)
    {
        let instance = this
        $.ajax({
            url: '/local/ajax/api/basket/get.php',
            method: 'POST',
            data: {id: id},
            success: function(e) {
                e.forEach(function(item){
                    let parent = $('.js-item-detail[data-element-id="'+item+'"]')
                    parent.find('.js-add-to-basket').addClass('d-none')
                    parent.find('.js-basket-added').removeClass('d-none')
                    $('.btn--plus[data-id="'+item+'"]').addClass('is-check')
                })

                setTimeout(function(){
                    if (e.length > 0){
                        document.querySelector('.js-basket-top-count').innerHTML = e.length
                    }
                }, 1000)
            }
        })
    }
}